document.body.classList.add('page-loading');

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll('.js-breed-tabs-item.active').length > 0) {
    changeBreedTabs(document.querySelector('.js-breed-tabs-item.active').getAttribute('data-id'), false);
  } else {
    document.body.classList.remove('page-loading');
  }

  document.querySelectorAll('.js-breed-tabs-item').forEach((tab) => {
    tab.addEventListener('click', (e) => {
      if (!e.currentTarget.classList.contains('active')) {
        if (document.querySelectorAll('.js-breed-tabs-item.active').length > 0) {
          document.querySelector('.js-breed-tabs-item.active').classList.remove('active');
        }

        e.currentTarget.classList.add('active');
        changeBreedTabs(e.currentTarget.getAttribute('data-id'), true);
      }
    });
  });
});

function changeBreedTabs(id, isLoading) {
  if (isLoading) {
    document.body.classList.add('page-loading');
  }

  const TAB_ELMS = document.querySelectorAll('.section-tab-content');
  
  if (TAB_ELMS.length > 0) {
    TAB_ELMS.forEach((el) => {
      if (el.getAttribute('data-id') == id) {
        el.classList.remove('hidden');

        if (el.classList.contains('section-breed-ingredients') && el.querySelectorAll("breed-ingredients").length > 0 && !el.querySelector("breed-ingredients").classList.contains('flickity-enabled')) {
          let ingredientsSlide = el.querySelector("breed-ingredients");
          let ingredientsFlkty = new Flickity(ingredientsSlide, {
            cellAlign: 'left',
            pageDots: false,
            adaptiveHeight: false,
            prevNextButtons: true,
            imagesLoaded: true,
            wrapAround: true
          });
          if (el.querySelectorAll('.js-breed-ingredients-prev').length > 0) {
            document.querySelector('.js-breed-ingredients-prev').addEventListener("click", () => {
              ingredientsFlkty.previous();
            });
          }
          if (document.querySelectorAll('.js-breed-ingredients-next').length > 0) {
            document.querySelector('.js-breed-ingredients-next').addEventListener("click", () => {
              ingredientsFlkty.next();
            });
          }
        }

        if (el.querySelectorAll('.js-breed-rebuy').length > 0 && !el.querySelector('.js-breed-rebuy').classList.contains('rebuy-loaded') && window.Rebuy && typeof window.Rebuy.init === 'function') {
            el.querySelector('.js-breed-rebuy').classList.add('rebuy-loaded');
            window.Rebuy.init();
        }
      } else {
        el.classList.add('hidden');
      }
    });
  }

  setTimeout(() => {
    document.body.classList.remove('page-loading');
  }, 500);
}